import React from 'react';

export const BedIcon = () => (
  <svg
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5214 4.71325C21.5214 4.16097 21.0737 3.71325 20.5214 3.71325H18.3739C17.8216 3.71325 17.3739 4.16097 17.3739 4.71325V5.43487C16.8584 4.86391 16.1125 4.50507 15.2827 4.50507H9.50307C8.86755 4.50507 8.28118 4.71555 7.80989 5.07062C7.4447 4.42843 6.75428 3.9953 5.96271 3.9953C5.62986 3.9953 5.3149 4.07188 5.03448 4.20838V1.74677C5.03448 1.19448 4.58676 0.746765 4.03448 0.746765H1.87866C1.32638 0.746765 0.878662 1.19448 0.878662 1.74677V12.363C0.878662 12.9153 1.32638 13.363 1.87866 13.363H4.03448C4.58677 13.363 5.03448 12.9153 5.03448 12.363V11.7182H17.3739V12.3629C17.3739 12.9152 17.8216 13.3629 18.3739 13.3629H20.5214C21.0737 13.3629 21.5214 12.9152 21.5214 12.3629V4.71325ZM3.83448 8.25475V1.94677H2.07866V12.163H3.83448V10.5182H18.5739V12.1629H20.3214V4.91325H18.5739V8.25475H3.83448ZM9.50307 5.70507H15.2827C16.0846 5.70507 16.7501 6.28894 16.8773 7.05475H7.90843C8.03411 6.29824 8.69992 5.70507 9.50307 5.70507ZM5.96271 7.04225C5.45269 7.04225 5.03923 6.6288 5.03923 6.11877C5.03923 5.60875 5.45269 5.1953 5.96271 5.1953C6.47273 5.1953 6.88618 5.60875 6.88618 6.11877C6.88618 6.60987 6.45485 7.04225 5.96271 7.04225Z"
      fill="currentColor"
    />
  </svg>
);
